var map = {
	"./OTM_ALGORITHMS.gif": 9659,
	"./OTM_CUMULATIVE.gif": 6444,
	"./OTM_DELTA_BAR.gif": 8659,
	"./OTM_DELTA_BAR_FREE.jpg": 4311,
	"./OTM_MICRO.gif": 8355,
	"./OTM_PROFILE.gif": 1920,
	"./OTM_SWING.gif": 9717,
	"./OTM_VWAP.gif": 1683,
	"./OTM_VWAP_FREE.jpg": 6135
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8763;